import {RemotePostFavoritePlace} from 'data/usecases';
import {PostFavoritePlace} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makePostFavoritePlace = (): PostFavoritePlace =>
  new RemotePostFavoritePlace(
    makeBFFApiUrl(GuideFlowEndpoints.medicalFavoritePlace),
    makeAuthorizeHttpClientDecorator(),
  );
